import { render, staticRenderFns } from "./whatson.vue?vue&type=template&id=62054e3a"
import script from "./whatson.vue?vue&type=script&lang=js"
export * from "./whatson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports